import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography, Button } from '@mui/material'
import BookedLessonInfo from './BookedLessonInfo'
import TeacherInfo from './TeacherInfo'
import {
  cancelBookedLessonByStudent,
  getBookedLessonById,
  confirmOrderSucceeded,
  createAComplaint
} from '../../../actions/learningScheduleForStudent'
import { connect } from 'react-redux'
import Spinner from '../../ui/Spinner'
import { useConfirm } from 'material-ui-confirm'
import SmsIcon from '@mui/icons-material/Sms';
import CreatingAComplaintDialog from './CreatingAComplaintDialog'
import ComplaintAboutBookedLesson from './ComplaintAboutBookedLesson'
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { toast } from 'react-toastify'
import RateReviewIcon from '@mui/icons-material/RateReview'
import AddReview from './AddReview'

const BookedLesson = ({
  match,
  cancelBookedLessonByStudent,
  confirmOrderSucceeded,
  createAComplaint,
  getBookedLessonById,
  learningScheduleForStudent: { loading, bookedLesson },
  profileTeacher: { loading: loadingProfileTeacher, profileTeacher },
}) => {
  const [openCreatingComplaintDialog, setOpenCreatingComplaintDialog] = useState(false)
  const [openAddReviewDialog, setOpenAddReviewDialog] = useState(false)

  const handleOpenReviewDialog = () => {
    setOpenAddReviewDialog(true)
  }

  console.log('bookedLesson:', bookedLesson)

  const handleCloseReviewDialog = () => {
    setOpenAddReviewDialog(false)
  }

  const handleCloseCreatingComplaintDialog = () => {
    setOpenCreatingComplaintDialog(false)
  }

  const handleConfirmOrderSucceeded = (bookedLessonId) => {
    confirm({
      description: 'Nhấn đồng ý sẽ xác nhận bài học thành công.',
      title: 'Bạn có muốn xác nhận bài học thành công không?',
    })
      .then(() => {
        confirmOrderSucceeded(bookedLessonId)

        toast.success('Bạn đã xác nhận bài học thành công!')
      })
      .catch(() => { })
  }

  const confirm = useConfirm()

  useEffect(() => {
    getBookedLessonById(match.params.bookedLessonId)
  }, [getBookedLessonById, match.params.bookedLessonId])

  const currentTime = new Date()

  let isConfirmOrderSucceededBtnDisabled = false
  if (bookedLesson && bookedLesson.isSucceeded) {
    isConfirmOrderSucceededBtnDisabled = true
  } else if (bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime[0] && new Date().getTime() < new Date(bookedLesson.bookedTime[0].start).getTime()) {
    isConfirmOrderSucceededBtnDisabled = true
  } else if (bookedLesson && bookedLesson.complaint && bookedLesson.complaint.content) {
    isConfirmOrderSucceededBtnDisabled = true
  }

  let isSendReviewBtnDisabled = false
  if (bookedLesson && bookedLesson.isReviewed) {
    isSendReviewBtnDisabled = true
  } else if (bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime[0] && new Date().getTime() < new Date(bookedLesson.bookedTime[0].start).getTime()) {
    isSendReviewBtnDisabled = true
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className="container"
      spacing={2}
      style={{ width: '100%', margin: '0' }}
    >
      <Grid item>
        <Typography
          variant="h4"
          style={{ textTransform: 'uppercase', fontWeight: '600' }}
        >
          Thông tin về bài học
        </Typography>
      </Grid>

      <Grid item>
        {loading ? (
          <Spinner />
        ) : (
          <BookedLessonInfo bookedLesson={bookedLesson} />
        )}
      </Grid>

      {bookedLesson && bookedLesson.complaint && bookedLesson.complaint.content && <Grid item>
        {loading ? (
          <Spinner />
        ) : (
          <ComplaintAboutBookedLesson bookedLesson={bookedLesson} />
        )}
      </Grid>}

      <Grid item>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            {loading ? (
              <Spinner />
            ) : (
              <TeacherInfo profileTeacher={bookedLesson.profileTeacher} teacherInfo={bookedLesson.teacher} />
            )}
          </Grid>

          <Grid item container justifyContent='center' alignItems="center" spacing={1} direction='column'>
            {/* <Grid item>
                <Button
                  onClick={() => handleCancelLesson(bookedLesson._id)}
                  variant="contained"
                  style={{ color: 'white' }}
                  color='secondary'
                  disabled={bookedLesson.isSucceeded || bookedLesson.isComplained || isAfterNext24Hours(bookedLesson.createdAt)}
                >
                  <CancelIcon />
                  &nbsp;Hủy bài học
                </Button>
              </Grid>  */}

            <Grid item>
              <Button
                onClick={() => { setOpenCreatingComplaintDialog(true) }}
                variant="contained"
                style={{ color: 'white' }}
                color='secondary'
                disabled={bookedLesson.isComplained || bookedLesson.isSucceeded || (bookedLesson && bookedLesson.bookedTime && bookedLesson.bookedTime.length && (currentTime.getTime() < new Date(bookedLesson.bookedTime[0].start).getTime()))}
              >
                <SmsIcon />
                &nbsp;Gửi khiếu nại
              </Button>
            </Grid>

            <Grid item>
              <Button
                onClick={() => { handleConfirmOrderSucceeded(bookedLesson._id) }}
                variant="contained"
                style={{ color: 'white' }}
                color='primary'
                disabled={isConfirmOrderSucceededBtnDisabled}
              >
                <DoneOutlineIcon />
                &nbsp;Xác nhận bài học thành công
              </Button>
            </Grid>

            <Grid item>
              <Button onClick={handleOpenReviewDialog} color='primary' variant='contained' style={{ color: 'white' }} disabled={isSendReviewBtnDisabled}>
                <RateReviewIcon />
                &nbsp;Gửi nhận xét về giáo viên
              </Button>

              <AddReview
                openAddReviewDialog={openAddReviewDialog}
                handleClose={handleCloseReviewDialog}
                teacherId={bookedLesson.teacher}
              />
            </Grid>
          </Grid>

          <Grid item>
            <CreatingAComplaintDialog open={openCreatingComplaintDialog} handleClose={handleCloseCreatingComplaintDialog} createAComplaint={createAComplaint} bookedLessonId={match.params.bookedLessonId} />
          </Grid>
        </Grid>
      </Grid >
    </Grid >
  );
}

BookedLesson.propTypes = {
  getBookedLessonById: PropTypes.func.isRequired,
  learningScheduleForStudent: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  learningScheduleForStudent: state.learningScheduleForStudent,
  profileTeacher: state.profileTeacher,
})

export default connect(mapStateToProps, {
  getBookedLessonById,
  cancelBookedLessonByStudent,
  confirmOrderSucceeded,
  createAComplaint
})(BookedLesson)
